// extracted by mini-css-extract-plugin
export var divider = "divider-module--divider--b41ba";